<div class="container-fluid ptp-wrapper">
	<div class="overlayDiv">
		<span class="buttonGroup">
			Filter:&nbsp;
			<button mat-stroked-button [color]="allSelected" (click)="resetFilters()">ALL</button>
			<mat-form-field style="margin-left: 10px;" appearance="outline" class="custom-mat-field">
				<mat-label>Portfolios</mat-label>
				<mat-select [(ngModel)]="selectedValue" (selectionChange)="filterPortfolio($event)">
					<mat-option *ngFor="let portfolio of portfolios" [value]="portfolio">{{portfolio}}</mat-option>
				</mat-select>
			</mat-form-field>
			<button [color]="brokenSelected" mat-stroked-button
				(click)="brokenPTPList()">Broken PTP (NSF)</button>
			<button [color]="maturedSelected" mat-stroked-button
				(click)="maturedList()">Matured</button>
			<button [color]="unTouchedSelected" mat-stroked-button (click)="unTouched()">Untouched</button>
			<button *ngIf="isAssignCollectorAllowed" mat-flat-button color="primary" (click) = "customAssignCollectors()">Custom Assign</button>
		</span>
	</div>
	<div class="row" style="height: calc(100% - 30px);">
		<app-custom-table class="ag-theme-material" class="collection-wrapper" [rowData]="rowData_Collection"
			[showLoader]="showLoader" [columnDefs]="columnDefs_Collection" [hideGlobalFilter]="true"
			[animateRows]="true" [pagination]="true" [paginationPageSize]="10000" [rowClassRules]="rowClassRules"
			(gridReady)="onGridReady($event)">
		</app-custom-table>
	</div>
</div>